import { render, staticRenderFns } from "./StudyPlanComponent.vue?vue&type=template&id=42bfeea3&scoped=true"
import script from "./StudyPlanComponent.vue?vue&type=script&lang=js"
export * from "./StudyPlanComponent.vue?vue&type=script&lang=js"
import style0 from "./StudyPlanComponent.vue?vue&type=style&index=0&id=42bfeea3&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bfeea3",
  null
  
)

export default component.exports